import Vue from "vue";
import App from "./App";
import router from "./router";
import Truncate from "lodash.truncate";
import api from "./api";
import jquery from "jquery";
import Vuex from "vuex";
import VueFlashMessage from "vue-flash-message";
import VuePlyr from "vue-plyr";
// import 'vue-plyr/dist/vue-plyr.css';
import "./pages/videozone/plyr.css";

Vue.use(VueFlashMessage);
Vue.use(Vuex);
Vue.use(VuePlyr);

import Vuetify, {
  // VApp, // required
  VTabs,
  VTab
} from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";
import store from "./store"

Vue.use(Vuetify, {
  components: {
    //   VApp,
    VTabs,
    VTab
  },
  directives: {
    Ripple
  }
});

Vue.config.productionTip = false;
// Helpers
// Global filters
Vue.filter("truncate", Truncate);
//Vue.use(VeeValidate, {fieldsBagName: 'formFields'});

Vue.prototype.$api = api;
Vue.prototype.$t = api.translation;

/* eslint-disable no-new */
api.bus.init(new Vue(), jquery());

api.toaster.init();

api.login.mounted(() => {
  new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"
  });
});



// WEBPACK FOOTER //
// ./src/public_app/main.js